import React from "react";
import PropTypes from "prop-types";

const InternalUseIcon = (props) => {
  const { width = "86", height = "86" } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 86 86"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.9443 59.0355C66.8448 62.4323 64.0988 65.3838 60.862 67.7224L57.2904 62.7791C59.88 60.9081 62.077 58.5468 63.7567 55.8292L68.9443 59.0355Z"
        fill="#FFD400"
      />
      <path
        d="M18.475 24.8682C20.8489 21.6572 23.8303 18.9437 27.2499 16.8815L30.3991 22.1039C27.6633 23.7537 25.2781 25.9247 23.3788 28.4937L18.475 24.8682Z"
        fill="#FFD400"
      />
      <path
        d="M67.4909 61.1774C65.111 64.384 62.1246 67.092 58.7012 69.1477L55.5617 63.9195C58.3006 62.2748 60.6898 60.1082 62.5939 57.5428L67.4909 61.1774Z"
        fill="#FFD400"
      />
      <path
        d="M29.3954 15.7024C32.9694 13.9212 36.8583 12.8592 40.8415 12.5766L41.2731 18.6598C38.0863 18.8859 34.975 19.7355 32.1156 21.1606L29.3954 15.7024Z"
        fill="#FFD400"
      />
      <path
        d="M45.0719 12.5705C49.0559 12.8418 52.9479 13.8928 56.5269 15.6638L53.8221 21.1297C50.9587 19.7128 47.845 18.8719 44.6576 18.6549L45.0719 12.5705Z"
        fill="#FFD400"
      />
      <path
        d="M59.4046 17.2877C62.771 19.4356 65.6829 22.2236 67.9749 25.4935L62.9811 28.9939C61.1473 26.3778 58.8177 24.1473 56.1244 22.4289L59.4046 17.2877Z"
        fill="#FFD400"
      />
      <path
        d="M70.0006 28.8151C71.8577 32.3502 73.0026 36.2156 73.3703 40.1919L67.2977 40.7533C67.0035 37.5721 66.0876 34.4796 64.6018 31.6514L70.0006 28.8151Z"
        fill="#FFD400"
      />
      <path
        d="M73.4722 44.2904C73.3033 48.28 72.3525 52.1977 70.6739 55.8209L65.1404 53.2574C66.4834 50.3586 67.244 47.2243 67.3792 44.0323L73.4722 44.2904Z"
        fill="#FFD400"
      />
      <path
        d="M12.9767 37.6312C13.6796 33.7003 15.1476 29.9457 17.2973 26.5806L22.4367 29.8636C20.7168 32.5559 19.5423 35.5598 18.98 38.7047L12.9767 37.6312Z"
        fill="#FFD400"
      />
      <path
        d="M13.9582 52.3178C12.7383 48.5155 12.2769 44.5106 12.6002 40.5305L18.6787 41.0243C18.42 44.2086 18.7892 47.4127 19.7652 50.4547L13.9582 52.3178Z"
        fill="#FFD400"
      />
      <path
        d="M22.1774 65.286C19.2596 62.5598 16.9056 59.2871 15.2489 55.6538L20.7977 53.1236C22.1232 56.0305 24.0065 58.6488 26.3409 60.8299L22.1774 65.286Z"
        fill="#FFD400"
      />
      <path
        d="M37.2856 72.9599C33.3631 72.2117 29.6256 70.7006 26.2854 68.5122L29.6275 63.411C32.2998 65.1618 35.29 66.3708 38.4282 66.9694L37.2856 72.9599Z"
        fill="#FFD400"
      />
      <path
        d="M54.4632 71.2636C50.7627 72.7645 46.8036 73.5241 42.8104 73.4993L42.8483 67.401C46.043 67.4208 49.2105 66.8131 52.1711 65.6123L54.4632 71.2636Z"
        fill="#FFD400"
      />
    </svg>
  );
};

InternalUseIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default InternalUseIcon;
